import { FC } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { IKeyFeaturesData } from '@pro/linearTopLight/interface';
import { GridRender } from '@base/snippets/GridRender';
import { HtmlRender } from '@base/snippets/HtmlRender';
import { ModuleHeader } from '@app/linearTopLight/ModuleHeader';
import Image from '@base/lib/ThemeImage';

type IKeyFeaturesProps = {
    data: IKeyFeaturesData;
};

export const KeyFeatures: FC<IKeyFeaturesProps> = ({ data }) => {
    return (
        <div className={cn(styles['key-features'], 'g-wrapper')}>
            <ModuleHeader title={data.title} center/>

            <GridRender
                colsPerRow={3}
                gutter={[48, 128]}
                list={data.list}
                render={item => (
                    <div className={cn(styles.item, 'flex flex-middle')}>
                        <Image
                            src={item.icon}
                            width={68}
                            fixed
                            background={false}
                            pure
                        />
                        <HtmlRender className={cn(styles['item-title'], 'flex-1 g-font-ext-light')} html={item.title}/>
                    </div>
                )}
            />
        </div>
    )
};
